/**
 * Canvas Save Helper for UI-Model-1
 *
 * Extracts properly-shaped SaveDataByType['canvas'] from UIModelState.
 * Used by all sites that call enqueueSave('canvas', ...) to ensure
 * the correct data shape (with pageId, groupId, containers) is sent.
 */

import { UIModelState, ContainerAPI } from '../types/state.types';
import { SaveDataByType } from '../services/SaveQueue';

export const buildCanvasSaveData = (
  state: UIModelState,
  canvasId: string
): SaveDataByType['canvas'] | null => {
  const canvas = state.model?.layout?.canvas?.[canvasId];
  if (!canvas || !canvas.pageId) return null;
  return {
    canvasId,
    pageId: canvas.pageId,
    groupId: canvas.groupId,
    containers: ensureNestedSubmodels(canvas.containers || []),
  };
};

/**
 * Ensures nested containers inherit content.submodel from their parent.
 * The preview renderer expects every nested container to carry the submodel reference.
 */
const ensureNestedSubmodels = (containers: ContainerAPI[]): ContainerAPI[] => {
  return containers.map(container => {
    const parentSubmodel = container.content?.submodel;
    if (!parentSubmodel || !container.content?.nestedContainers?.length) {
      return container;
    }
    const updatedNested = container.content.nestedContainers.map(nested => {
      if (nested.content?.submodel) return nested;
      return {
        ...nested,
        content: {
          ...nested.content,
          submodel: parentSubmodel,
        },
      };
    });
    return {
      ...container,
      content: {
        ...container.content,
        nestedContainers: updatedNested,
      },
    };
  });
};
